export enum SpriteName {
	ANCIENT_DRAGON = "ancient_dragon_sprite",
	BACKGROUND = "background_sprite",
	BULLET = "bullet_sprite",
	BULLET_IMPACT = "bullet_impact_sprite",
	BUTTON = "button_sprite",
	BUTTON_PRIMARY = "button_primary_sprite",
	CLOUD = "cloud_sprite",
	CONTAINER = "container_sprite",
	DRAGON = "dragon_sprite",
	FIRE_ORB = "fire_orb_sprite",
	FLOOR_GRASS_1 = "floor_grass_1_sprite",
	FLOOR_GRASS_2 = "floor_grass_2_sprite",
	FLOOR_GRASS_3 = "floor_grass_3_sprite",
	FLOOR_GRASS_4 = "floor_grass_4_sprite",
	FLOOR_GRASS_5 = "floor_grass_5_sprite",
	FLOOR_GRASS_6 = "floor_grass_6_sprite",
	FLOOR_ROCK_1 = "floor_rock_1_sprite",
	FLOOR_ROCK_2 = "floor_rock_2_sprite",
	FLOOR_ROCK_3 = "floor_rock_3_sprite",
	FLOOR_ROCK_4 = "floor_rock_4_sprite",
	FLOOR_ROCK_5 = "floor_rock_5_sprite",
	FLOOR_ROCK_6 = "floor_rock_6_sprite",
	GAME_OVER = "game_over_sprite",
	INVINCIBLE_IMPACT = "invincible_impact_sprite",
	OBSTICLE_1 = "obsticle_1_sprite",
	OBSTICLE_2 = "obsticle_2_sprite",
	PLAYER = "player_sprite",
	SHOCKWAVE = "shockwave_sprite",
}
